import { useState, useEffect } from 'react'
import { api } from '../../utils/api'

export default function ImageQualityTable({ dealId }) {
  const [scores, setScores] = useState(null)
  const [loading, setLoading] = useState(false)
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (!dealId || !expanded) return
    setLoading(true)
    api.get(`/api/deals/${dealId}/image-quality`)
      .then(data => setScores(data.scores || []))
      .catch(() => setScores([]))
      .finally(() => setLoading(false))
  }, [dealId, expanded])

  if (!dealId) return null

  const avgScore = scores && scores.length > 0
    ? Math.round(scores.reduce((sum, s) => sum + (s.composite_score || 0), 0) / scores.length * 10) / 10
    : null

  return (
    <div style={{ marginTop: 'var(--space-2)' }}>
      <button
        className="btn btn-xs btn-secondary"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? 'Hide Image Quality' : 'Show Image Quality'}
      </button>
      {expanded && (
        loading ? (
          <div style={{ padding: 'var(--space-2)', fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>Loading...</div>
        ) : scores && scores.length > 0 ? (
          <div style={{ marginTop: 'var(--space-2)', overflowX: 'auto' }}>
            <table style={{ width: '100%', fontSize: '0.75rem', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--color-border)', textAlign: 'left' }}>
                  <th style={{ padding: '4px 6px' }}>Image</th>
                  <th style={{ padding: '4px 6px' }}>OCR Conf</th>
                  <th style={{ padding: '4px 6px' }}>Lines</th>
                  <th style={{ padding: '4px 6px' }}>Serials</th>
                  <th style={{ padding: '4px 6px' }}>Models</th>
                  <th style={{ padding: '4px 6px' }}>Resolution</th>
                  <th style={{ padding: '4px 6px' }}>Vision</th>
                  <th style={{ padding: '4px 6px', fontWeight: 'bold' }}>Score</th>
                </tr>
              </thead>
              <tbody>
                {scores.map((s, idx) => (
                  <tr key={idx} style={{ borderBottom: '1px solid var(--color-border-light)' }}>
                    <td style={{ padding: '3px 6px', fontFamily: 'monospace' }}>{s.image_filename || `img_${s.image_index}`}</td>
                    <td style={{ padding: '3px 6px' }}>{s.ocr_avg_confidence != null ? s.ocr_avg_confidence.toFixed(2) : '-'}</td>
                    <td style={{ padding: '3px 6px' }}>{s.ocr_line_count ?? '-'}</td>
                    <td style={{ padding: '3px 6px' }}>{s.ocr_serial_candidates ?? '-'}</td>
                    <td style={{ padding: '3px 6px' }}>{s.ocr_model_candidates ?? '-'}</td>
                    <td style={{ padding: '3px 6px' }}>{s.resolution_width && s.resolution_height ? `${s.resolution_width}x${s.resolution_height}` : '-'}</td>
                    <td style={{ padding: '3px 6px' }}>{s.vision_confidence != null ? s.vision_confidence.toFixed(1) : '-'}</td>
                    <td style={{ padding: '3px 6px', fontWeight: 'bold' }}>{s.composite_score != null ? s.composite_score.toFixed(1) : '-'}</td>
                  </tr>
                ))}
                <tr style={{ borderTop: '2px solid var(--color-border)', fontWeight: 'bold' }}>
                  <td style={{ padding: '4px 6px' }} colSpan={7}>Average</td>
                  <td style={{ padding: '4px 6px' }}>{avgScore != null ? avgScore.toFixed(1) : '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: 'var(--space-2)', fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>No quality scores available</div>
        )
      )}
    </div>
  )
}
